module.exports = __webpack_public_path__ + "img/purpleBg.eb93969a.png";